import React from "react";

const CommonTitle = ({ text }) => {
  return <span className="commonTitle--text">{text}</span>;
};

export default CommonTitle;
